import { CartPaymentCardType } from 'generated/graphql-gateway';
import { ISOs } from 'utils/form/constants';

import { IPaymentMethod } from './types';

export const CASH_ACCOUNT_IDENTIFIER = CartPaymentCardType.CASH;
export const CASH_APP_ACCOUNT_IDENTIFIER = CartPaymentCardType.CASHAPP;
export const PAYPAL_ACCOUNT_IDENTIFIER = CartPaymentCardType.PAYPAL;
export const VENMO_ACCOUNT_IDENTIFIER = CartPaymentCardType.VENMO;

export const CASH_APP_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  fdAccountId: CASH_APP_ACCOUNT_IDENTIFIER,
  accountIdentifier: CASH_APP_ACCOUNT_IDENTIFIER,
  orbitalIdentifier: null,
  credit: null,
  paypal: false,
  prepaid: null,
  venmo: false,
  cashapp: true,
};
export const PAYPAL_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  fdAccountId: PAYPAL_ACCOUNT_IDENTIFIER,
  accountIdentifier: PAYPAL_ACCOUNT_IDENTIFIER,
  orbitalIdentifier: null,
  credit: null,
  paypal: true,
  prepaid: null,
  venmo: false,
  cashapp: false,
};
export const VENMO_PAYMENT_METHOD_PLACEHOLDER: IPaymentMethod = {
  paypal: false,
  fdAccountId: VENMO_ACCOUNT_IDENTIFIER,
  accountIdentifier: VENMO_ACCOUNT_IDENTIFIER,
  orbitalIdentifier: null,
  credit: null,
  prepaid: null,
  venmo: true,
  cashapp: false,
};

export const DEFAULT_BILLING_COUNTRY = ISOs.USA;
